import axios from 'axios';
import { API_URL } from '@/config';

// Nastavenie základnej URL - hybridné riešenie pre development aj production (viď config.js)
axios.defaults.baseURL = API_URL;

// Pridanie autentifikačného tokenu do všetkých API volaní
axios.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Endpointy, ktorých 401 neznamená vypršané prihlásenie: zlé heslo pri prihlásení / zmene hesla,
// odhlásenie a overenie tokenu pri štarte (to rieši router guard cez checkAuth)
const BEZ_ODHLASENIA = /\/auth\/(login|logout|me|change-password|forgot-password|reset-password)(\?|$)/;

let odhlasovanieBezi = false;

// Token, s ktorým bola požiadavka odoslaná
const tokenPoziadavky = (config) => {
  const hlavicky = config && config.headers;
  if (!hlavicky) return null;
  const hodnota = typeof hlavicky.get === 'function' ? hlavicky.get('Authorization') : hlavicky.Authorization;
  return hodnota ? String(hodnota).replace(/^Bearer\s+/i, '') : null;
};

// Neplatný alebo expirovaný token: odhlásiť a presmerovať na prihlásenie s návratom na aktuálnu stránku.
// Store a router sa načítajú lenivo (inak kruhová závislosť router -> store -> axios).
async function odhlasitPoVyprsaniTokenu() {
  if (odhlasovanieBezi) return;
  odhlasovanieBezi = true;
  try {
    const [{ useAuthStore }, { useNotificationStore }, { default: router }] = await Promise.all([
      import('@/store/auth'),
      import('@/store/notification'),
      import('@/router')
    ]);
    const authStore = useAuthStore();
    authStore.clearAuth();

    const aktualna = router.currentRoute.value;
    if (aktualna.name !== 'login' && aktualna.meta?.requiresAuth !== false) {
      await router.push({
        name: 'login',
        query: aktualna.fullPath && aktualna.fullPath !== '/' ? { redirect: aktualna.fullPath } : {}
      });
    }

    // Až po presmerovaní - inak by hlášku hneď prepísala chyba stránky („Nepodarilo sa načítať…“)
    useNotificationStore().show({
      text: 'Vaše prihlásenie vypršalo. Prihláste sa znova.',
      color: 'warning'
    });
  } catch (e) {
    console.error('Chyba pri odhlásení po vypršaní prihlásenia:', e);
  } finally {
    odhlasovanieBezi = false;
  }
}

// Interceptor pre logovanie chýb a spracovanie vypršaného prihlásenia (401)
axios.interceptors.response.use(
  response => response,
  error => {
    console.error('API Error:', error.response ? error.response.data : error.message);

    if (error.response?.status === 401 && !BEZ_ODHLASENIA.test(error.config?.url || '')) {
      // Len ak požiadavka išla s aktuálnym tokenom - oneskorená odpoveď so starým tokenom
      // nesmie odhlásiť používateľa, ktorý sa medzitým znova prihlásil
      const token = tokenPoziadavky(error.config);
      if (token && token === localStorage.getItem('token')) {
        odhlasitPoVyprsaniTokenu();
      }
    }

    return Promise.reject(error);
  }
);

export default axios;
